exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, ".settings-basic {\n  margin-top: 20px;\n  padding: 20px; }\n  .settings-basic .save-btn {\n    text-align: right; }\n\n@media only screen and (max-width: 968px) {\n  .settings-basic {\n    overflow: auto; }\n    .settings-basic .column {\n      padding-bottom: 0 !important; }\n      .settings-basic .column div > div {\n        margin-bottom: 5px; } }\n\n@media only screen and (max-width: 600px) {\n  .settings-basic {\n    margin: 10px 10px;\n    height: calc(100vh - 250px); }\n    .settings-basic .column {\n      width: 100%; }\n    .settings-basic .settings-item {\n      width: 100%; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/screens/settings/basic/index.scss
// module id = 1603
// module chunks = 0